<div class="content">
  <span
    class="item"
    [class.cursor-default]="!tooltip"
    [rtTooltip]="tooltip"
    [rtTooltipHasTextAlignCenter]="true"
    [rtTooltipPosition]="tooltipPosition"
  >
    <rt-icon [name]="icon" [colorToken]="iconColor" /><span
      [class.bold]="isBold"
      [innerHTML]="label"
      class="label"
    ></span>
  </span>
</div>
